import {createEntityAdapter, EntityState} from '@reduxjs/toolkit';

import {ProfilePackage} from '../../models';

export const type = 'profile-package';

export interface ProfilePackagesState extends EntityState<ProfilePackage, number> {
    isFetching: boolean;
    selectedId: number | null;
    activeCustomer: ProfilePackage | null;
    errorMessage?: string;
}

export const adapter = createEntityAdapter<ProfilePackage>({
});

export const initialState: ProfilePackagesState = adapter.getInitialState({
    isFetching: false,
    selectedId: null,
    activeCustomer: null,
    errorMessage: undefined,
});
